<template>
    <CCollapse>
        <slot />
    </CCollapse>
</template>

<script setup>
import { CCollapse } from '@coreui/vue-pro'
</script>

<style scoped>

</style>
